const VideoHelper = {
  videoGroups: {},
  // eslint-disable-next-line object-shorthand
  addVideoPlayer: function (groupName, videoPlayer) {
    if (this.videoGroups[groupName]) {
      this.videoGroups[groupName].push(videoPlayer);
    } else {
      this.videoGroups[groupName] = [videoPlayer];
    }
  },
  // eslint-disable-next-line object-shorthand
  stopOtherPlayers: function (groupName, videoPlayerId) {
    if (this.videoGroups[groupName]) {
      for (const item of this.videoGroups[groupName]) {
        if (item.id !== videoPlayerId) {
          const player = item.player;
          player.el.classList.remove('video-card--playing');
          if (player.dom.vimeoVideo) {
            player.vimeoPlayer.pause();
          } else {
            player.dom.localVideo.pause();
          }
        }
      }
    }
  }
};

export default VideoHelper;
